import { defineMessages } from 'react-intl';

export default defineMessages({
    yourEmployerHeader: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.yourEmployerHeader',
        defaultMessage: 'Employer or Affiliation'
    },
    employerNotListed: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.employerNotListed',
        defaultMessage: 'My employer or affiliation is not listed'
    },
    organizationName: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.organizationName',
        defaultMessage: '{organizationName}'
    },
    gpcCode: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.gpcCode',
        defaultMessage: 'GPC Code: {gpcCode}'
    },
    payPeriod: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.payPeriod',
        defaultMessage: '{payPeriod}'
    },
    paypointNumber: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.paypointNumber',
        defaultMessage: 'Paypoint Number: {paypointNumber}'
    },
    paypointCommentsConsumer: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.paypointCommentsConsumer',
        defaultMessage: 'Comments: {paypointCommentsConsumer}'
    },
    paypointEligibilityComments: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.paypointEligibilityComments',
        defaultMessage: 'Paypoint Eligibility Comments: {paypointEligibilityComments}'
    },
    paypointEligibilityCommentsConsumer: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.paypointEligibilityCommentsConsumer',
        defaultMessage: 'Paypoint Eligibility Comments: {paypointCommentsConsumer}'
    },
    paypointName: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.paypointName',
        defaultMessage: '{paypointName}'
    },
    editButton: {
        id: 'ml.quoteandbind.common.employeraffilitationsummarycard.editButton',
        defaultMessage: 'Edit'
    }
});
